import React, { useState } from 'react';
import { apiFetch } from '../jscontrol/apiClient';
import { pickRecordId } from '../jscontrol/recordUtils';
import '../css/Category.css';

const ProductAttributeEdit = ({ editItem, onClose, onSuccess }) => {
  const attributeId = pickRecordId(editItem, 'ProductAttributeId', 'productAttributeId', 'AttributeId', 'attributeId');
  const [form, setForm] = useState({
    AttributeName: editItem.AttributeName || '',
    IsActive: editItem.IsActive !== undefined ? editItem.IsActive : true,
  });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSave = async () => {
    if (!form.AttributeName.trim()) {
      setFormError('Attribute Name is required.');
      return;
    }
    if (!attributeId) {
      setFormError('Invalid attribute record. Close and try again.');
      return;
    }
    setSaving(true);
    setFormError(null);
    try {
      await apiFetch('/ProductAttribute/Update', {
        method: 'PUT',
        data: {
          ProductAttributeId: attributeId,
          AttributeName: form.AttributeName,
          IsActive: form.IsActive,
          UpdatedBy: 0,
        },
      });
      onSuccess('Attribute updated successfully.');
    } catch (e) {
      setFormError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="cat-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="cat-modal">
        <div className="cat-modal-header">
          <h5>Edit Attribute</h5>
          <button className="cat-modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="cat-modal-body">
          {formError && (
            <div className="alert alert-danger py-2 mb-3">{formError}</div>
          )}

          <div className="form-group mb-3">
            <label className="form-label">
              Attribute Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              name="AttributeName"
              value={form.AttributeName}
              onChange={handleChange}
              placeholder="Enter attribute name"
            />
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              name="IsActive"
              id="attrEditIsActive"
              checked={form.IsActive}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="attrEditIsActive">Active</label>
          </div>
        </div>

        <div className="cat-modal-footer">
          <button className="btn btn-light me-2" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                Saving...
              </>
            ) : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductAttributeEdit;
